export const selectDataWithIds = arrayArg => {
  return arrayArg.map(item => ({
    id: item,
    name: item
  }))
}
